/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  Common,
  CreateDistributorDtoTx,
  DeleteDistributorDtoTx,
  DistributorControllerCheckDistributorParams,
  DistributorControllerGetDistributorsParams,
  GetDetailDistributorDtoRx,
  GetDistributorDtoRx,
  UpdateDistributorDtoTx,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class DistributorApi<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Distributor API
   * @name DistributorControllerGetDistributors
   * @summary 총판 조회
   * @request GET:/api/distributor
   * @secure
   */
  distributorControllerGetDistributors = (
    query: DistributorControllerGetDistributorsParams,
    params: RequestParams = {},
  ) =>
    this.request<GetDistributorDtoRx, any>({
      path: `/api/distributor`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Distributor API
   * @name DistributorControllerCreateDistributor
   * @summary 총판 등록
   * @request POST:/api/distributor
   * @secure
   */
  distributorControllerCreateDistributor = (data: CreateDistributorDtoTx, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/distributor`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Distributor API
   * @name DistributorControllerDeleteDistributor
   * @summary 총판 삭제
   * @request DELETE:/api/distributor
   * @secure
   */
  distributorControllerDeleteDistributor = (data: DeleteDistributorDtoTx, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/distributor`,
      method: 'DELETE',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Distributor API
   * @name DistributorControllerCheckDistributor
   * @summary 총판 중복 조회
   * @request GET:/api/distributor/check
   * @secure
   */
  distributorControllerCheckDistributor = (
    query: DistributorControllerCheckDistributorParams,
    params: RequestParams = {},
  ) =>
    this.request<Common, any>({
      path: `/api/distributor/check`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Distributor API
   * @name DistributorControllerGetDistributor
   * @summary 총판 상세 조회
   * @request GET:/api/distributor/{id}
   * @secure
   */
  distributorControllerGetDistributor = (id: number, params: RequestParams = {}) =>
    this.request<GetDetailDistributorDtoRx, any>({
      path: `/api/distributor/${id}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Distributor API
   * @name DistributorControllerUpdateDistributor
   * @summary 총판 수정
   * @request PUT:/api/distributor/{id}
   * @secure
   */
  distributorControllerUpdateDistributor = (id: number, data: UpdateDistributorDtoTx, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/distributor/${id}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
